import ResearchAndDevSection from "./ResearchAndDevSection";
import RnDServicesSection from "./RnDServicesSection";
import RnDInitiative from "./RnDInitiative";
import Footer from "../common/Footer";
import Header from "../common/Header";

const ResearchPage = () => {
  return (
    <div>
      <Header />
      <ResearchAndDevSection />
      <RnDServicesSection />
      <RnDInitiative />
      <Footer />
    </div>
  );
};

export default ResearchPage;
